<script lang="ts">
    import type { Snippet } from "svelte";

    interface Props {
        children?: Snippet | null;
    }

    let { children = null, ...rest }: Props = $props();

    let element: HTMLVideoElement | null = $state(null);

    export function getElement() {
        return element;
    }
</script>


    <video bind:this={element} {...rest}>
        {@render children?.()}
    </video>

